var React = require('react');

function sort() {
    return <g><path d="M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z" xmlns="http://www.w3.org/2000/svg"/><path d="M0 0h24v24H0z" fill="none" xmlns="http://www.w3.org/2000/svg"/></g>
}
module.exports = sort
